export const SALES = "sales";
export const ADMIN = "admin";
export const OPERATIONS = "operations";
